import { LucideIcon } from "lucide-react";

interface StepHeaderProps {
  icon: LucideIcon;
  title: string;
  description: string;
  size?: 'default' | 'compact';
}

export function StepHeader({ icon: Icon, title, description, size = 'compact' }: StepHeaderProps) {
  const iconSize = size === 'default' ? 'w-20 h-20' : 'w-16 h-16';
  const innerIconSize = size === 'default' ? 'w-10 h-10' : 'w-8 h-8';
  const titleSize = size === 'default' ? 'text-2xl' : 'text-xl';
  const marginBottom = size === 'default' ? 'mb-6' : 'mb-4';

  return (
    <div className="text-center mb-4">
      <div className={`${iconSize} rounded-full evolve-gradient flex items-center justify-center mx-auto ${marginBottom} pulse-glow animate-fade-in`}>
        <Icon className={`${innerIconSize} text-foreground`} />
      </div>
      <h1 className={`font-display ${titleSize} font-bold animate-fade-in`}>{title}</h1>
      <p className="text-sm text-muted-foreground mt-1 animate-fade-in">{description}</p>
    </div>
  );
}
